__turbopack_context__.v({
  "scrollable-container": "scrollable-container-module-scss-module__5BghIW__scrollable-container",
});
